'use strict';

//dependencies included for running in node
if (typeof exports !== 'undefined') {
	if (typeof module !== 'undefined' && module.exports) {
		var Gender = require('../lib/gender');
	}
}

//life expectancy table returns life expectancy for gender and current age
var LifeExpectancyTable = function(expectancies) {
	this.male = expectancies.male;
	this.female = expectancies.female;
	
};

LifeExpectancyTable.prototype.getExpectancy = function(gender, currentAge) {
	var table = gender == Gender.MALE ? this.male : this.female;	

	if(currentAge > table.length - 1) {
		throw Error('DC-Engine: Invalid expectancy lookup with current age: ' + currentAge);
	}

	return table[currentAge];
};


LifeExpectancyTable.prototype.expectancies = function(gender) {
	if(gender == Gender.MALE) {
		return this.male;
	}

	if(gender == Gender.FEMALE) {
		return this.female;
	}

	return null;
};

//export for node
if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
        exports = module.exports = LifeExpectancyTable;
    }
    exports.LifeExpectancyTable = LifeExpectancyTable;
}